import { ReactNode } from 'react'
import clsx from 'clsx'

export interface TileOption {
    value: string
    content: ReactNode
}

interface TileGridProps {
    label: string
    required?: boolean
    columns?: number
    value: string | undefined
    onChange: (value: string) => void
    options: TileOption[]
    className?: string
}

export default function TileGrid({ label, required, columns = 2, value, onChange, options, className }: TileGridProps) {
    return (
        <div className="form-field">
            <div className="label">
                <span>
                    {label}
                    {required && <span style={{ color: 'red' }}>&nbsp;*</span>}
                </span>
            </div>
            <div
                className={clsx('tile-grid', className)}
                style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
            >
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={clsx('tile', { selected: value === option.value })}
                        onClick={() => onChange(option.value)}
                    >
                        {option.content}
                    </button>
                ))}
            </div>
        </div>
    )
}
